module.exports = "<v-container fluid fill-height justify-center>\n  <div class=\"display-4\">\n    <v-icon large>fa fa-braille </v-icon>\n  </div>\n  <!-- <v-btn @click=\"handleSignout\" color=\"indigo\" dark>Sign out </v-btn> -->\n\n</v-container>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/error/template.html
// module id = FLOJ
// module chunks = 0